/* tslint:disable */
/* eslint-disable */
/**
 * Credify API doc version 2
 * API documentations version 2.
 *
 * The version of the OpenAPI document: 1.0.0-oas3
 * Contact: dev@credify.one
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { GetAccounts200Response } from '../model';
// @ts-ignore
import { OrderStatusType } from '../model';
/**
 * BNPLApi - axios parameter creator
 * @export
 */
export const BNPLApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * This returns csv file of BNPL orders for MP. 
         * @summary Export BNPL orders
         * @param {string} startDate YYYY-MM-DD
         * @param {string} endDate YYYY-MM-DD
         * @param {Array<OrderStatusType>} [statuses] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportBnplOrder: async (startDate: string, endDate: string, statuses?: Array<OrderStatusType>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'startDate' is not null or undefined
            assertParamExists('exportBnplOrder', 'startDate', startDate)
            // verify required parameter 'endDate' is not null or undefined
            assertParamExists('exportBnplOrder', 'endDate', endDate)
            const localVarPath = `/v2/bnpl-consumer/orders/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (statuses) {
                localVarQueryParameter['statuses'] = statuses;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString().substr(0,10) :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString().substr(0,10) :
                    endDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This returns csv file of BNPL orders for Admin. 
         * @summary Export BNPL orders for admin
         * @param {string} providerId The UUID of a service provider
         * @param {string} consumerId The UUID of a MP
         * @param {string} startDate YYYY-MM-DD
         * @param {string} endDate YYYY-MM-DD
         * @param {Array<OrderStatusType>} [statuses] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportBnplOrderForAdmin: async (providerId: string, consumerId: string, startDate: string, endDate: string, statuses?: Array<OrderStatusType>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'providerId' is not null or undefined
            assertParamExists('exportBnplOrderForAdmin', 'providerId', providerId)
            // verify required parameter 'consumerId' is not null or undefined
            assertParamExists('exportBnplOrderForAdmin', 'consumerId', consumerId)
            // verify required parameter 'startDate' is not null or undefined
            assertParamExists('exportBnplOrderForAdmin', 'startDate', startDate)
            // verify required parameter 'endDate' is not null or undefined
            assertParamExists('exportBnplOrderForAdmin', 'endDate', endDate)
            const localVarPath = `/v2/admin/bnpl-orders/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (providerId !== undefined) {
                localVarQueryParameter['provider_id'] = providerId;
            }

            if (consumerId !== undefined) {
                localVarQueryParameter['consumer_id'] = consumerId;
            }

            if (statuses) {
                localVarQueryParameter['statuses'] = statuses;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString().substr(0,10) :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString().substr(0,10) :
                    endDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This returns all BNPL accounts of the current user. 
         * @summary Get accounts
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccounts: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/private/bnpl/accounts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BNPLApi - functional programming interface
 * @export
 */
export const BNPLApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BNPLApiAxiosParamCreator(configuration)
    return {
        /**
         * This returns csv file of BNPL orders for MP. 
         * @summary Export BNPL orders
         * @param {string} startDate YYYY-MM-DD
         * @param {string} endDate YYYY-MM-DD
         * @param {Array<OrderStatusType>} [statuses] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportBnplOrder(startDate: string, endDate: string, statuses?: Array<OrderStatusType>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportBnplOrder(startDate, endDate, statuses, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This returns csv file of BNPL orders for Admin. 
         * @summary Export BNPL orders for admin
         * @param {string} providerId The UUID of a service provider
         * @param {string} consumerId The UUID of a MP
         * @param {string} startDate YYYY-MM-DD
         * @param {string} endDate YYYY-MM-DD
         * @param {Array<OrderStatusType>} [statuses] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportBnplOrderForAdmin(providerId: string, consumerId: string, startDate: string, endDate: string, statuses?: Array<OrderStatusType>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportBnplOrderForAdmin(providerId, consumerId, startDate, endDate, statuses, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This returns all BNPL accounts of the current user. 
         * @summary Get accounts
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAccounts(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAccounts200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAccounts(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * BNPLApi - factory interface
 * @export
 */
export const BNPLApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BNPLApiFp(configuration)
    return {
        /**
         * This returns csv file of BNPL orders for MP. 
         * @summary Export BNPL orders
         * @param {string} startDate YYYY-MM-DD
         * @param {string} endDate YYYY-MM-DD
         * @param {Array<OrderStatusType>} [statuses] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportBnplOrder(startDate: string, endDate: string, statuses?: Array<OrderStatusType>, options?: any): AxiosPromise<string> {
            return localVarFp.exportBnplOrder(startDate, endDate, statuses, options).then((request) => request(axios, basePath));
        },
        /**
         * This returns csv file of BNPL orders for Admin. 
         * @summary Export BNPL orders for admin
         * @param {string} providerId The UUID of a service provider
         * @param {string} consumerId The UUID of a MP
         * @param {string} startDate YYYY-MM-DD
         * @param {string} endDate YYYY-MM-DD
         * @param {Array<OrderStatusType>} [statuses] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportBnplOrderForAdmin(providerId: string, consumerId: string, startDate: string, endDate: string, statuses?: Array<OrderStatusType>, options?: any): AxiosPromise<string> {
            return localVarFp.exportBnplOrderForAdmin(providerId, consumerId, startDate, endDate, statuses, options).then((request) => request(axios, basePath));
        },
        /**
         * This returns all BNPL accounts of the current user. 
         * @summary Get accounts
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccounts(options?: any): AxiosPromise<GetAccounts200Response> {
            return localVarFp.getAccounts(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BNPLApi - interface
 * @export
 * @interface BNPLApi
 */
export interface BNPLApiInterface {
    /**
     * This returns csv file of BNPL orders for MP. 
     * @summary Export BNPL orders
     * @param {string} startDate YYYY-MM-DD
     * @param {string} endDate YYYY-MM-DD
     * @param {Array<OrderStatusType>} [statuses] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BNPLApiInterface
     */
    exportBnplOrder(startDate: string, endDate: string, statuses?: Array<OrderStatusType>, options?: AxiosRequestConfig): AxiosPromise<string>;

    /**
     * This returns csv file of BNPL orders for Admin. 
     * @summary Export BNPL orders for admin
     * @param {string} providerId The UUID of a service provider
     * @param {string} consumerId The UUID of a MP
     * @param {string} startDate YYYY-MM-DD
     * @param {string} endDate YYYY-MM-DD
     * @param {Array<OrderStatusType>} [statuses] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BNPLApiInterface
     */
    exportBnplOrderForAdmin(providerId: string, consumerId: string, startDate: string, endDate: string, statuses?: Array<OrderStatusType>, options?: AxiosRequestConfig): AxiosPromise<string>;

    /**
     * This returns all BNPL accounts of the current user. 
     * @summary Get accounts
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BNPLApiInterface
     */
    getAccounts(options?: AxiosRequestConfig): AxiosPromise<GetAccounts200Response>;

}

/**
 * BNPLApi - object-oriented interface
 * @export
 * @class BNPLApi
 * @extends {BaseAPI}
 */
export class BNPLApi extends BaseAPI implements BNPLApiInterface {
    /**
     * This returns csv file of BNPL orders for MP. 
     * @summary Export BNPL orders
     * @param {string} startDate YYYY-MM-DD
     * @param {string} endDate YYYY-MM-DD
     * @param {Array<OrderStatusType>} [statuses] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BNPLApi
     */
    public exportBnplOrder(startDate: string, endDate: string, statuses?: Array<OrderStatusType>, options?: AxiosRequestConfig) {
        return BNPLApiFp(this.configuration).exportBnplOrder(startDate, endDate, statuses, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This returns csv file of BNPL orders for Admin. 
     * @summary Export BNPL orders for admin
     * @param {string} providerId The UUID of a service provider
     * @param {string} consumerId The UUID of a MP
     * @param {string} startDate YYYY-MM-DD
     * @param {string} endDate YYYY-MM-DD
     * @param {Array<OrderStatusType>} [statuses] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BNPLApi
     */
    public exportBnplOrderForAdmin(providerId: string, consumerId: string, startDate: string, endDate: string, statuses?: Array<OrderStatusType>, options?: AxiosRequestConfig) {
        return BNPLApiFp(this.configuration).exportBnplOrderForAdmin(providerId, consumerId, startDate, endDate, statuses, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This returns all BNPL accounts of the current user. 
     * @summary Get accounts
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BNPLApi
     */
    public getAccounts(options?: AxiosRequestConfig) {
        return BNPLApiFp(this.configuration).getAccounts(options).then((request) => request(this.axios, this.basePath));
    }
}
